import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://0.0.0.0:8055';


export interface MetaTranslation {
  id: number;
  meta_id: string;
  languages_code: string; 
  title: string;
  keywords: string;
  description: string;
  og_title: string;
  og_description: string;
  robots_content: string;
}

export interface MetaData {
  id: string;
  translations: MetaTranslation[];
  og_image?: {
    id: string;
    filename_download: string;
  };
}

export const fetchMetaInfo = async (): Promise<MetaData> => {
  try {
    const response = await axios.get(`${API_URL}/items/meta`, {
      params: {
        fields: ['translations.*', 'id', 'og_image'],
      },
    });
    return response.data.data;
  } catch (error) {
    console.error('Error fetching meta information:', error);
    throw error;
  }
};

